import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

export const ContextAttributes = props => {
  return (
    <Fragment>
      <ul>
        <li>Tracked on: {props.context.createDate}</li>
        <li>Context ID: {props.context.contextId}</li>
        <li>Context Title: {props.context.contextTitle}</li>
        <li>
          LMS Course PK:{' '}
          {props.context.lmsCourseId ? props.context.lmsCourseId : 'None'}
        </li>
      </ul>
    </Fragment>
  )
}

ContextAttributes.propTypes = {
  context: PropTypes.object.isRequired,
}
